import { EmployeeTeamResponse } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { EmployeeTeamDto } from "./dto/employee-team.dto";
import { EmployeeTeamRequest } from "./dto/employee-team.request";
import { EmployeeTeamService } from "./employee-team.service";

@ApiTags('employeeTeam')
@Controller('employeeTeam')
export class EmployeeTeamController {
    constructor(
        private service : EmployeeTeamService,
        private readonly applicationExceptionHandler : ApplicationExceptionHandler
    ){}

    @Post('/createEmployeeTeam')
    async createEmployeeTeam(@Body() Dto:EmployeeTeamDto , isUpdate:boolean = false):Promise<EmployeeTeamResponse>{
        try{
            return await this.service.createEmployeeTeam(Dto,false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTeamResponse,error);
        }
    }
    
    @Post('/updateEmployeeTeam')
    async updateEmployeeTeam(@Body() Dto:EmployeeTeamDto, isUpdate:boolean = false):Promise<EmployeeTeamResponse>{
        try{
            return await this.service.createEmployeeTeam(Dto,true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTeamResponse,error)
        }
    }

    @Post('/getAllEmployeeTeamActions')
    async getAllEmployeeTeamActions():Promise<EmployeeTeamResponse>{
        try{
            return await this.service.getAllEmployeeTeamActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTeamResponse,error)
        }
    }


    
    @Post('/getAllEmployeeTeamActiveActions')
    async getAllActiveEmployeeTeamActions():Promise<EmployeeTeamResponse>{
        try{
            return await this.service.getAllActiveEmployeeTeamActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTeamResponse,error)
        }
    }

    @Post('/activateOrDeactivateEmployeeTeam')
    async activateOrDeactivateEmployeeTeam(@Body() empReq:EmployeeTeamRequest):Promise<EmployeeTeamResponse>{
        try{
            return await this.service.activateOrDeactivateEmployeeTeam(empReq)
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTeamResponse,error)
        }
    }

    
}